import { URL, URLsmall } from '../../config.js';
import Errors from '../../handlers/Errors';
import {axios} from '../../handlers/RequestHandler';
import store from '../store';
import { tableUpdate, tableRemoveAcount }from './tableActions';
import moment from 'moment';
import Notification from '../../handlers/Notification';
import { UNLIMITED_STOCK, COMPANY_ACCESS, DEFAULT_TIME_ZONE } from '../../constants/general';
import { orderStatus, orderHasFlag, isPickUp,FloatPrecision, localizedErrorHandler, number_format } from './UtilsOperation';
import { mergeArrays, removeFromArray } from '../../handlers/utils';

const priotizeOrders = (priority, orders) => {
    let orderList = [], auxList = [];
    switch(priority){
        case "unassigned":
            orders.forEach((item) => {
                if(item.is_shopper_allowed ){
                    if(!item.is_shopper_assigned){
                        orderList.push(item);
                    }else if(!item.is_status_prepared){
                        auxList.push(item);
                    } else if(!item.is_provider_assigned) {
                        orderList.push(item);
                    }else {
                        auxList.push(item);
                    }
                }else if(!item.is_provider_assigned){
                    orderList.push(item);  // sin asignar
                }
                else
                    auxList.push(item);
            })
            return [orderList.concat(auxList), orderList.length, auxList.length];
        default: break;
    }
}

const find = (id) => {
    return (dispatch,getState) => {
        return axios.get(URL + getState().company.id + '/orders/' + id).then( (res) => {
            dispatch({
                type: 'FETCH_ORDER',
                order: res.data
            })
        }).catch((err) => {
            var dataError = Errors(err);
            dispatch({
                type: 'ERROR',
                errors: dataError
            });
        });
    }
}


const findOrderWithAvaliableProviders = () => {
    return (dispatch,getState) => {
		dispatch({type: "WAIT_FOR_RESPONSE"})
		const { company, bids,order, goodsList, json_lang } = getState();
            return axios.get(`${URL + company.id}/providers?limit=0&with=skills,account,accesses`).then( (res) => {
                var setPosition = res.data.map( (provider) => {
                    provider.position =[parseInt(provider.latitude_e6,10)/1000000,parseInt(provider.longitude_e6,10)/1000000]
                    return (provider)
                })


                let asignableProviders = setPosition.filter( (asignable,key) => {
                    let found;
                    let isAsignable = asignable;
                    if(bids){
                        found = bids.find((bidsProvider) => bidsProvider.provider_id === asignable.id);
                        if(found){ isAsignable =  asignable.id !== found.provider_id }
                    }
                    return isAsignable
                })


                let goodsInOrder = order && order.ordered_goods.map((ordered_good,key) => {
                    return ordered_good.good_id;
                })


                let providerForGoods = goodsList.filter((good) => goodsInOrder.includes(good.id));

                // let productosConProveedoresAsignables = [];
                // if(asignableProviders){
                //     productosConProveedoresAsignables = order && order.ordered_goods.map((ordered_good, key) => {

                //         var addtest = providerForGoods.find((providerForGood) => providerForGood.id === ordered_good.good_id);
                //         asignableProviders.filter((asignable) => addtest && addtest.allowed_providers.includes(asignable.id));
                //         ordered_good.allowed_providers =  asignableProviders.filter((asignable) => addtest && addtest.allowed_providers.includes(asignable.id));

                //         ordered_good.assigned_provider = null;
                //         return ordered_good;
                //     })
                // }
                dispatch({
                    type: 'FETCH_ORDER',
                    order: order
                })
            }).catch((err) => {
                if(err.message && err.message !== 'generic')
                    Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
                else
                    Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.retrieving_user_list });
            });

    }
}

const fetchOrders = (page = 1, search_query = '', filter_query = '', sort = '', city_id = "all", limit = 20) => {
    return (dispatch,getState) => {
		dispatch({type: "WAIT_FOR_RESPONSE"})//orderProviders.provider
		const { company, branch,session } = getState();
        let url_host = `${URL + company.id}/orders?page=${page}&with=client,branch.city,creator,taxes.coupon&limit=${limit}`;
        if(branch && branch.id){
            url_host= `${URL + company.id}/branches/${branch.id}/orders?page=${page}&with=client,creator,taxes.coupon&limit=${limit}`;
        }
        url_host += (search_query !== '') ? ('&search=' + search_query) : '';
        url_host += (filter_query !== '') ? ('&'+filter_query) : '';
        url_host += (sort !== '') ? (`&sort_by=${sort.columnName},${sort.direction}`) : '';
        url_host += (city_id !== "all") ? (`&city_id=${city_id}`) : '';
        return axios.get(url_host).then( (res) => {
            for(let i = 0; i < res.data.data.length; ++i) {
                moment(res.data.data[i].updated_at).diff( moment(res.data.data[i].created_at) ) < 15000
                    ? res.data.data[i].touched = false
                    : res.data.data[i].touched = true
            }
            // let dataToDraw = res.data.data;
            // if( session && session.admin_type && session.admin_type.id && parseInt(session.admin_type.id,10) === 2 ){
            //     dataToDraw = res.data.data.filter((order) =>  order.status_data.payment_confirmed === true )
            // }

            dispatch({
                type: 'FETCH_ORDERS',
                orders: res.data,
                archived_orders: []
            })
        }).catch((err) => {
            dispatch({type: "REMOVE_LOADING"});
             if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title: `Acceso denegado al intentar obtener listado de ordenes`});
        });
    }
}

const fetchProofOfDelivery = (id) => {
    return (dispatch,getState) => {
        return axios.get(URL + getState().company.id + '/orders/' + id + '/proof-of-deliveries').then( (res) => {
            dispatch({
                type: 'FETCH_PROOF_DELIVERY',
                proofDelivery: res.data
            })
        }).catch((err) => {
            console.log(err)
        });
    }
}

const resetDataDetailsOrder = () => {
    return (dispatch,getState) => {
        dispatch({
            type: 'RESET_DATA_DETAILS_ORDER',
            orderDetails: {
                client_id:"",
                client_latitude_e6:0,
                client_longitude_e6:0,
                scheduled_at:"",
                notes:"",
                goods:[],
                providers_id:"",
                propertiesGood:[],
                taxes:[]
            }
        })
    }
}

const updateOrderView = (order) => {
    return (dispatch,getState) => {
        const { orderDetails } = getState();
        dispatch({
            type: 'FETCH_ORDER_DETAILS',
            orderDetails: {
                ...orderDetails,
                ...order
            }
        })
    }
}
const updateOrdersView = (new_order,type) => {
    return (dispatch,getState) => {
        const branch = { ...getState().branch };
        var orders_list = {...getState().orders};
        const order = {...getState().order};

        const newOrderId = new_order.order_id ? new_order.order_id : new_order.id;

        if(orders_list.data){
            if(type === "neworder"){
                const findOrder = orders_list.data.find((order) => order.id === newOrderId);
                if(findOrder){
                    return;
                }else{
                    if(branch.id){
                        if(branch.id === new_order.branch_id){
                            return axios.get(`${URL+getState().company.id}/orders/${newOrderId}?with=taxes.coupon,taxes.author.admin,order_providers,branch`).then( (res) => {
                                new_order = res.data;
                                orders_list = {
                                    ...orders_list,
                                    data: [...orders_list.data].concat(new_order)
                                }
                                orders_list.data = [...orders_list.data]
                                setTimeout(() => {
                                    dispatch({
                                        type: 'FETCH_ORDERS',
                                        orders: orders_list,
                                        archived_orders: []
                                    })
                                    if(order && order.id){
                                        if(order.id === newOrderId){
                                            dispatch({
                                                type: 'FETCH_ORDER',
                                                order: new_order
                                            })
                                        }
                                    }
                                },100)
                            }).catch((err) => {
                                console.log(err)
                            });
                        }
                         else{
                            if(order && order.id){
                                if(order.id === newOrderId){
                                    dispatch({
                                        type: 'FETCH_ORDER',
                                        order: new_order
                                    })
                                }
                            } else {
                                return;
                            }
                        }
                    }else{
                        return axios.get(`${URL+getState().company.id}/orders/${newOrderId}?with=taxes.coupon,taxes.author.admin,order_providers,branch`).then( (res) => {
                            new_order = res.data;
                            orders_list = {
                                ...orders_list,
                                data: [...orders_list.data].concat(new_order)
                            }
                            orders_list.data = [...orders_list.data]
                            setTimeout(() => {
                                dispatch({
                                    type: 'FETCH_ORDERS',
                                    orders: orders_list,
                                    archived_orders: []
                                })
                                if(order && order.id){
                                    if(order.id === newOrderId){
                                        dispatch({
                                            type: 'FETCH_ORDER',
                                            order: new_order
                                        })
                                    }
                                }
                            },100)
                        }).catch((err) => {
                            console.log(err)
                        });
                    }
                }
            }
            else{
                let index = orders_list.data.findIndex(order => order.id === newOrderId);
                if(index !== -1){
                    orders_list.data[index] = {
                        ...orders_list.data[index],
                        ...new_order
                    }

                    orders_list.data = [...orders_list.data]

                    setTimeout(() => {
                        dispatch({
                            type: 'FETCH_ORDERS',
                            orders: orders_list,
                            archived_orders: []
                        })
                    },100)
                }
                if(order && order.id){
                    if(order.id === newOrderId){
                        setTimeout(() => {
                            dispatch({
                                type: 'FETCH_ORDER',
                                order: new_order
                            })
                        }, 100)
                    }
                }
            }
            setTimeout(() => {
                dispatch({
                    type: 'FETCH_ORDERS',
                    orders: orders_list,
                    archived_orders: []
                })
                if(order && order.id){
                    if(order.id === newOrderId){
                        dispatch({
                            type: 'FETCH_ORDER',
                            order: new_order
                        })
                    }
                }
            },100)
        }
    }
}

const fetchOrderDetails = (id, withAddresses = false) => {
    return (dispatch,getState) => {
        dispatch({ type: "WAIT_FOR_RESPONSE" })
        return axios.get(`${URL+getState().company.id}/orders/${id}?with=taxes.coupon,taxes.author.admin,creator,order_providers,branch${withAddresses ? ',client.addresses' : ''}`).then( (res) => {
            dispatch({
                type: 'FETCH_ORDER_DETAILS',
                orderDetails: res.data,
            })
        }).catch((err) => {
            var dataError = Errors(err);
            dispatch({
                type: 'ERROR',
                errors: dataError
            })
        });
    }
}

const toggleData = (value) => {
    var update ='';
    return (dispatch,getState) => {
        var data = {...getState().order}

        if(value.name === "goods_id"){
            data.propertiesGood=[];
        }

        if(value.name === "propertiesGood"){
            var find = data.propertiesGood.find( (item) => {
               return item === value.data
            })

            if(find){
                update = data.propertiesGood.filter( (item) => {
                    return (item !== value.data && item !== "")
                })
            }else{
              update = data.propertiesGood.concat(value.data )
            }

            data.propertiesGood= update
        }else{
            data[value.name] = value.data;
        }
        dispatch({
            type: 'FETCH_ORDER',
            order: data
        })
    }
}

const addPickupOptionToOrder = (data) => {
    let obj = { ...store.getState().cart };
    obj.isPickup = data === "pickup";
    obj.client_address = null

    return {
        type: 'BUILD_ORDER',
        cart: obj,
        provider:undefined
    }
}

const addInstructionsToOrder = (notes) => {
    let obj = { ...store.getState().cart };
    obj.notes = notes;

    return {
        type: 'BUILD_ORDER',
        cart: obj
    }
}

const addDeliveryMethodToOrder = (data) => {
    let obj = { ...store.getState().cart };
    obj.delivery_method = data;

    if(data === "asap")
        obj.scheduled_at = "";

    return {
        type: 'BUILD_ORDER',
        cart: obj
    }
}

const addClientAddressToOrder = (address) => {
    let obj = { ...store.getState().cart };
    //let addr = store.getState().order_client_address_query;
    if(address){
        obj.client_address = address.display_name;
        obj.client_latitude_e6 = parseInt((parseFloat(address.lat) * 1000000).toFixed(),10);
        obj.client_longitude_e6 = parseInt((parseFloat(address.lon) * 1000000).toFixed(),10);

        return {
            type: 'BUILD_ORDER',
            cart: obj
        }
    }

    else {
        /* xHACER: q tome lo q selecciono antes y le adjunte lo q escribio luego */
        /*  Notification.show({
            type: 'error',
            title:'',
            msg:store.getState().json_lang.custom_errors.select_complete_address
        }); */
        delete obj.client_address;
        obj.client_latitude_e6 = 0;
        obj.client_longitude_e6 = 0;

        return {
            type: 'BUILD_ORDER',
            cart: obj
        }
    }
}

const addScheduleToOrder = (schedule) => {
    let obj = { ...store.getState().cart };
    obj.scheduled_at = moment.utc(schedule).format("YYYY-MM-DD HH:mm:ss");

    return {
        type: 'BUILD_ORDER',
        cart: obj
    }
}

const addClientToOrder = (data) => {
    return {
        type: 'ASSIGN_CLIENT_TO_ORDER',
        client: data
    }
}

const addProviderToOrder = (data) => {
    return {
        type: 'ASSIGN_PROVIDER_TO_ORDER',
        provider: data,
        isPickup: false
    }
}

const addPropertiesToOrder = (data, good_id, input_type) => {
    let prevAddedProperty,
        obj = { ...store.getState().cart },
        prevAddedGood = obj.goods.findIndex((item) => {
            return item.id === good_id;
        });

    data.temp_base_price = data.price;
    if(obj.goods[prevAddedGood].properties === undefined){
        obj.goods[prevAddedGood]["properties"] = [];
        obj.goods[prevAddedGood].properties.push(data);
    }
    else {
        data.price = data.temp_base_price * obj.goods[prevAddedGood].quantity;

        switch(input_type){
            case "checkbox":
                prevAddedProperty = obj.goods[prevAddedGood].properties.findIndex((item) => {  // debo preguntar si ya existe este value y eliminarlo si vuelve a llegar
                    return item.value === data.value;
                });

                if(prevAddedProperty !== -1)  // si ya existe la property
                    obj.goods[prevAddedGood].properties = obj.goods[prevAddedGood].properties
                            .filter( (item, idx, properties) =>
                                item.value !== properties[prevAddedProperty].value
                            )
                else
                    obj.goods[prevAddedGood].properties.push(data);
                break;


            default:
                prevAddedProperty = obj.goods[prevAddedGood].properties.findIndex((item) => {
                    return item.property_id === data.property_id;
                });

                if(prevAddedProperty !== -1)  // si ya existe la property
                    obj.goods[prevAddedGood].properties[prevAddedProperty] = data;
                else
                    obj.goods[prevAddedGood].properties.push(data);
                break;
        }
    }

    return {
        type: 'BUILD_ORDER',
        cart: obj
    }
}

const update = (data,type) => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        var properties={
            name:data.name,
            type:data.type,
            mandatory:data.mandatory ? data.mandatory: false,
        }
        if(type === 256){
           properties.property_options = data.property_options;
        }else if(type === 512){
            properties.property_range = data.property_range;
        }else if(type === 1024){
            properties.property_text = data.property_text;
        }
        axios.put(URL + getState().company.id + '/properties/' + data.id , properties ).then( (res) => {

        }).catch( (err) => {
            var dataError = Errors(err);
            dispatch({
                type: 'ERROR',
                errors: dataError
            })
        })
    }
}

const register = (data,type) => {
    return (dispatch,getState) => {
       var properties={
            name:data.name,
            type:data.type,
            mandatory:data.mandatory ? data.mandatory: false,
        }
        if(type === 256){
           properties.property_options = data.property_options;
        }else if(type === 512){
            properties.property_range = data.property_range;
        }else if(type === 1024){
            properties.property_text = data.property_text;
        }

        axios.post(URL + getState().company.id + '/properties', properties ).then( (res) => {

        }).catch( (err) => {
            var dataError = Errors(err);
            dispatch({
                type: 'ERROR',
                errors: dataError
            })
        })
    }
}

const destroy = (id) => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        axios.delete(URL + getState().company.id + '/accounts/'+ id)
        .then( (res) => {
            var newdata = tableRemoveAcount(res);
            dispatch({
                type: 'SET_TABLE',
                table:  newdata
            });
        }).catch( (err) => {
            var dataError = Errors(err);
            dispatch({
                type: 'ERROR',
                errors: dataError
            })
        });
    }
}


const addToCart = (good) => {
    var propertyQuantity;
    return (dispatch, getState) => {
        let cart = { ...getState().cart };

        good.stock = good.quantity;
        good.quantity = good.apiQuantity > 0 ? good.apiQuantity : 1;
        good.total_price_e2 = good.min_price_e2;//price_e2;
        cart.goods.push(good)
        good.provider_id =''
        var itemsQuantity = {
            id: good.good_id,
            stock:good.stock,
            quantity:good.quantity
        }

        if(good.properties.length > 0){
            good.properties.map( (goodProperty,key) =>{
                var multiOptionInputs = goodProperty.type === 'checkbox' || goodProperty.type === 'select-one' || goodProperty.type === 'radio';
                propertyQuantity = {
                    id:multiOptionInputs ? goodProperty.value+'-'+goodProperty.property_id : goodProperty.property_id,
                    stock:goodProperty.quantity != null ? parseInt(goodProperty.quantity,10) : UNLIMITED_STOCK ,
                    quantity: goodProperty.type === 'range' ? parseInt(goodProperty.value,10) : good.quantity,
                }

                var propertiesInCart = cart.propertiesQuantity.find( (pQuantity,key ) => {
                    return pQuantity.id === propertyQuantity.id;
                });
                if(goodProperty.type === 'range'){
                    goodProperty.value = String(goodProperty.value)
                }

                if(!propertiesInCart){
                    cart.propertiesQuantity.push(propertyQuantity)
                }else{
                    cart.propertiesQuantity.map( (pQuantity,key ) => {
                        if(pQuantity.id === propertyQuantity.id){
                            pQuantity.quantity = pQuantity.quantity +propertyQuantity.quantity
                        }
                        return propertyQuantity
                    })
                }
                return goodProperty
            })
        }

        var goodIsInCart = cart.goodsQuantity.find( (goodQuantity,key ) => {
            return goodQuantity.id === itemsQuantity.id;
        });

        if(!goodIsInCart){
            cart.goodsQuantity.push(itemsQuantity)
        }else{
            cart.goodsQuantity.map( (goodQuantity,key ) => {
                if(goodQuantity.id ===itemsQuantity.id){
                    goodQuantity.quantity++
                }
                return goodQuantity
            })
        }
        dispatch({
            type: 'BUILD_ORDER',
            cart: cart
        })
    }
}

const removeGoodsFromOrder = (idx) => {
    return (dispatch, getState) => {
        let cart = { ...getState().cart };

        cart.goodsQuantity.map( (goodQuantity,Gkey ) => {
            if(goodQuantity.id === cart.goods[idx].id ){
                goodQuantity.quantity = goodQuantity.quantity-cart.goods[idx].quantity
            }

            if(goodQuantity.quantity <=0 ){
                cart.goodsQuantity.splice(Gkey, 1);
            }
            return goodQuantity
        })

        cart.propertiesQuantity.filter( (pQuantity,Pkey ) => {
            var propertyRemoved = cart.goods[idx].properties.find((property, Pkey) =>{
                var multiOptionInputs = property.type === 'checkbox' || property.type === 'select-one' || property.type === 'radio';
                var idReference = multiOptionInputs ? property.value+'-'+property.property_id : property.property_id;
                return idReference === pQuantity.id
            })
            if(propertyRemoved){

                if(propertyRemoved.type === 'range'){
                    pQuantity.quantity = pQuantity.quantity - propertyRemoved.value

                }
                else{
                    pQuantity.quantity = pQuantity.quantity - cart.goods[idx].quantity
                }
            }
            return pQuantity
        })

        cart.goods.splice(idx, 1);
        dispatch({
            type: 'BUILD_ORDER',
            cart: cart
        })
    }
}

const addQuantity = (idx) => {
    return (dispatch, getState) => {
        var cart = { ...getState().cart };

        cart.goods[idx].quantity++;
        cart.goods[idx].total_price_e2 = cart.goods[idx].price_e2 * cart.goods[idx].quantity;//cart.goods[idx].total_price_e2 +;

        cart.goods[idx].properties.map( (goodProprerty,propKey ) => {
            goodProprerty.price =  goodProprerty.temp_base_price * cart.goods[idx].quantity;
            var multiOptionInputs = goodProprerty.type === 'checkbox' || goodProprerty.type === 'select-one' || goodProprerty.type === 'radio';
            var idReference = multiOptionInputs ? goodProprerty.value+'-'+goodProprerty.property_id : goodProprerty.property_id;

            cart.propertiesQuantity.map( (pQuantity,key ) => {
                if(pQuantity.id === idReference){
                    pQuantity.quantity = goodProprerty.type === 'range' ? parseInt(goodProprerty.value,10) * cart.goods[idx].quantity : pQuantity.quantity+1
                }
                return pQuantity
            })

            return goodProprerty
        })


        cart.goodsQuantity.map( (goodQuantity,key ) => {
            if(goodQuantity.id === cart.goods[idx].id ){
                goodQuantity.quantity++
            }
            return goodQuantity
        })
        dispatch({
            type: 'BUILD_ORDER',
            cart: cart
        })
    }
}

const substractQuantity = (idx) => {
    return (dispatch, getState) => {
        var cart = { ...getState().cart };

        cart.goods[idx].quantity = cart.goods[idx].quantity > 1 ? (cart.goods[idx].quantity - 1) : 1;
        cart.goods[idx].total_price_e2 = cart.goods[idx].total_price_e2 - cart.goods[idx].price_e2
        cart.goods[idx].properties.map( (goodProprerty,propKey) => {
            goodProprerty.price =  goodProprerty.temp_base_price * cart.goods[idx].quantity;

            var multiOptionInputs = goodProprerty.type === 'checkbox' || goodProprerty.type === 'select-one' || goodProprerty.type === 'radio';
            var idReference = multiOptionInputs ? goodProprerty.value+'-'+goodProprerty.property_id : goodProprerty.property_id;

            cart.propertiesQuantity.map( (pQuantity,key) => {
                if(pQuantity.id === idReference){
                    var bandera = 0;
                    var deflt = 1;
                    if(goodProprerty.type === 'range'){
                        bandera = pQuantity.quantity - parseInt(goodProprerty.value,10);
                        deflt = goodProprerty.value
                    }else{
                        bandera = pQuantity.quantity - 1;
                    }
                    pQuantity.quantity = bandera > 0 ? bandera : deflt;
                }
                return goodProprerty
            })

            return goodProprerty
        })

        cart.goodsQuantity.map( (goodQuantity,key) => {
            if( goodQuantity.id === cart.goods[idx].id ) {
                if(goodQuantity.quantity > 0){
                    goodQuantity.quantity--
                }else{
                    goodQuantity.quantity = 1
                }
            }
            return goodQuantity
        })

        dispatch({
            type: 'BUILD_ORDER',
            cart: cart
        })
    }
}

const removePropertyFromOrder = (property_key, good_key) => {
    return (dispatch, getState) => {
        let cart = { ...getState().cart };
        let cartPropery = cart.goods[good_key].properties[property_key]

        cart.propertiesQuantity.map( (pQuantity,key ) => {

            var multiOptionInputs = cartPropery.type === 'checkbox' || cartPropery.type === 'select-one' || cartPropery.type === 'radio';
            var idReference = multiOptionInputs ? cartPropery.value+'-'+cartPropery.property_id : cartPropery.property_id;
            if(pQuantity.id === idReference ){
                pQuantity.quantity = cartPropery.type === 'range'?
                    pQuantity.quantity = pQuantity.quantity - cartPropery.value
                :
                    pQuantity.quantity = pQuantity.quantity - cart.goods[good_key].quantity
            }
            return pQuantity
        })

        cart.goods[good_key].properties.splice(property_key, 1);
        dispatch({
            type: 'BUILD_ORDER',
            cart: cart
        })
    }
}

const fetchArchivedOrders = (page = 1, search_query = '', filter_query = '', sort = '', city_id = "all", dates = null) => {
    return (dispatch, getState) => {
    const { branch } = getState();

        let url_host = URL + getState().company.id + '/orders?page=' + page + '&with=branch,orderProviders.provider,client,creator,taxes.coupon&mode=deleted';
        if(dates){
            url_host += `&created_at=between ${dates.dateStart} 00:00:00,${dates.dateEnd} 23:59:59`;
        }
        dispatch({type: "WAIT_FOR_RESPONSE"})
        if(branch && branch.id){
            url_host = `${URL+getState().company.id}/branches/${branch.id}/orders?page=${page}&with=branch,orderProviders.provider,client,creator,taxes.coupon&mode=deleted`;
        }
        url_host += (search_query !== '') ? ('&search=' + search_query) : '';
        url_host += (filter_query !== '') ? ('&'+filter_query) : '';
        url_host += (sort !== '') ? (`&sort_by=${sort.columnName},${sort.direction}`) : '';
        url_host += (city_id !== "all") ? (`&city_id=${city_id}`) : '';

       return axios.get(url_host)
            .then((res) => {
                dispatch({
                    type: 'FETCH_ARCHIVED_ORDERS',
                    archived_orders: res.data,
                    orders: []
                })
                return res.data
            }).catch((err) => {
                console.log("FETCH_ARCHIVED_ORDERS",err)

                dispatch({
                    type: 'ERROR',
                    errors: ""
                });
            });
    }
}


const addProviderToService = (goodKey,providerId) => {
    return (dispatch, getState) => {
        let cart = { ...getState().cart };
        if(providerId){
            var goodsIsInCart = cart.goods.map( (good,key ) => {
                if(key === goodKey){
                    good.provider_id=providerId.id
                }
                return good
            });
            cart.goods = goodsIsInCart
            dispatch({
                type: 'BUILD_ORDER',
                cart: cart
            })
        }
    }
}

const fetchOrdersByUserType = (page = 1, search_query = '', filter_query = '', isClient, userId) => {
    return (dispatch, getState) => {
        dispatch({
            type: "WAIT_FOR_RESPONSE"
        })

        let url_host = URL + getState().company.id;
        url_host += isClient ? '/clients/' : '/providers/';
        url_host += userId + '/orders?page=' + page + '&mode=all';
        //url_host += (search_query !== '') ? ('&search=' + search_query) : '';
        url_host += (filter_query !== '') ? ('&'+filter_query) : '';
        url_host += isClient ? '&with=order_providers.provider' : '&with=order';

        axios.get(url_host)
            .then((res) => {
                dispatch({
                    type: 'FETCH_ARCHIVED_ORDERS',
                    archived_orders: res.data,
                    orders: []
                })
            }).catch((err) => {
                var dataError = Errors(err);
                dispatch({
                    type: 'ERROR',
                    errors: dataError
                });
                dispatch({
                    type: "WAIT_FOR_RESPONSE"
                })
            });
    }
}

const fetchOrdersByProvider = (page = 1, search_query = '', filter_query = '', isClient, userId, sort) => {
    return (dispatch, getState) => {
        dispatch({
            type: "WAIT_FOR_RESPONSE"
        })

        // ${sort? `&sort_by=${sort.columnName},${sort.direction}` :``}
        // let url_host = `${URL + getState().company.id}/providers/${userId}/order-providers?page=${page}&with=order_providers.order`;
        let url_host = `${URL + getState().company.id}/providers/${userId}/order-providers?page=${page}${sort? `&sort_by=${sort.columnName},${sort.direction}` :``}`;

        axios.get(url_host)
            .then((res) => {
                dispatch({
                    type: 'FETCH_PROVIDER_ORDERS',
                    providerOrders: res.data
                })
            }).catch((err) => {
                var dataError = Errors(err);
                dispatch({
                    type: 'ERROR',
                    errors: dataError
                });
                dispatch({
                    type: "REMOVE_LOADING"
                })
            });
    }
}

const saveOrder = ({...data}, client_id, provider_id, searchType,forceProvider) => {
    return (dispatch , getState ) => {
		dispatch({type: "WAIT_FOR_RESPONSE"});
		const {
			company,
			branch,
			json_lang,
			cart,
			order_client_address_query
		} = getState();

        let options = parseInt(company.options,10);
        let isPickupSelected = cart.isPickup;
        let shiftService = searchType === "0" ? 0 : 12;
        if(provider_id){
            data.provider_id = provider_id;
        }

        data.client_address = data.client_address || order_client_address_query;

        if(!data.scheduled_at)
            delete data.scheduled_at;

        /* si la orden va por delivery */
        if(
                (( options & (512<<shiftService) ) === 0)
            &&
                !isPickupSelected
        ){
            /* if(!client_id){
                Notification.show({type: "error", title:"", msg:json_lang.custom_errors.insert_client });
                return;
            }
            if(!data.client_address){
                Notification.show({type: "error", title:"", msg:json_lang.custom_errors.insert_client_addres });ç
                return ;
            }
            else if(data.client_address.length > 255){
                Notification.show({type: "error", title:"", msg:json_lang.custom_errors.client_addres_to_long});
                return ;
            }
            if(data.goods.length === 0){
                Notification.show({type: "error", title:"", msg:json_lang.custom_errors.empty_shopping_cart});
                return ;
            }
            */
        }
        /* si la orden va por pickup */
        else if(
                (( options & (256<<shiftService) ) !== 0)
            &&
                isPickupSelected
        ){
            /* if(!client_id){
                Notification.show({type: "error", title:"", msg:json_lang.custom_errors.insert_client});
                return;
            } */
            if(data.goods.length === 0){
                Notification.show({type: "error", title:"", msg:json_lang.custom_errors.empty_shopping_cart});
                return ;
            }
            delete data.provider_id;
            delete data.client_address;
            data.client_latitude_e6 = 0;
            data.client_longitude_e6 = 0;

        }

        if (data.provider_id === "") {
          delete data.provider_id;
        }
        if (data.client_address === "") {
            delete data.client_address;
        }
        if(!client_id){
            Notification.show({type: "error", title:"", msg:json_lang.custom_errors.insert_client });
            return;
        }

        let new_goods = data.goods.map((good, idx) => {return {good_id: good.id, quantity: good.quantity, properties: good.properties,provider_id:provider_id ? provider_id : good.provider_id}} )
        data.goods = new_goods;

        if(forceProvider){
            data.force_providers =[forceProvider]
        }

        // dani was here
        if (!company.settings.enable_multi_providers) {
            new_goods = data.goods.map((good, idx) => {
                return {
                    good_id: good.good_id,
                    quantity: good.quantity,
                    properties: good.properties
                }
            })
            data.goods = new_goods;
        }

        return axios.post(`${URL + company.id}/branches/${branch.id}/clients/${client_id}/orders`, data).then( (res) => {
            Notification.show({type: "success", title: json_lang.common.success, msg:json_lang.custom_success.saved_successful});
            dispatch({
                type: 'ORDER_REGISTERED',
                order: res.data,
                reset_inputs: true
            })
        }).catch((err) => {

            if(err.message && err.message !== 'generic'){
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            }
            else {
                const msg = err.data.message.match( /([a-z_]+) [0-9]+ ([a-z 0-9áéíóúñ]+)/i );  // error format: "type_of_error ID Item Name"  // type its a specific error code, id its a number, alphanumeric item name

                if (msg && msg[1] === 'good_no_stock'){
                    Notification.show({type: "error", title: json_lang.custom_errors.insufficient_stock_title, msg: json_lang.custom_errors.insufficient_stock_msg });
                }
                else if (msg && msg[1] === 'property_no_stock'){
                    Notification.show({type: "error", title: json_lang.custom_errors.insufficient_stock_title, msg: json_lang.custom_errors.unavailable_product__msg.replace("{type}", json_lang.common.property).toLowerCase().replace("{item}", msg[2]) });
                }
                else if (msg && msg[1] === 'good_not_available') {
                    Notification.show({type: "error", title: json_lang.custom_errors.insufficient_stock_title, msg: json_lang.custom_errors.unavailable_product__msg.replace("{type}", json_lang.common.good).toLowerCase().replace("{item}", msg[2]) });
                }

                else if (msg && msg[1] === 'mixes_order_type') {
                    Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.unavailable_product__msg.replace("{type}", json_lang.common.good).toLowerCase().replace("{item}", msg[2]) });
                }
                else if (msg && msg[1] === 'mixes_order_type') {
                    Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: "La orden no puede contener producctos y servicios" });
                }
                else {
                    Notification.show({type: "error", title:err.title, msg:json_lang.custom_errors.order_registration_failed});
                }
            }
        });
    }
}

const registerNewOrder = () => {
    return {
        type: "REGISTER_NEW_ORDER"
    }
}

const updateShopper = (orderq,provider,action) => {
    //solo funciona con órdenes sin proveedor
    let provider_id= (typeof(provider)  === 'number') ? provider : provider[0].id;



    return (dispatch, getState) => {
		dispatch({ type: "WAIT_FOR_RESPONSE" })
		const { company, json_lang} = getState();
        return axios[action](`${URL}${ company.id}/orders/${orderq}/shoppers/${provider_id}`).then((res) => {
            Notification.show({type: "success", title: json_lang.common.success, msg: json_lang.custom_success.saved_successful});

        }).catch((err) => {
            if(err && err.data && err.data.error_code){
                const error = err.data;
                let message = error.description || error.message;
                let title = error.error_code;
                switch (error.error_code) {
                    case "ED202":
                    case "ED203":
                        message = "El shopper no se encuentra en línea";
                        break;
                    case "EC318":
                        message = "Shopper no asignable, no pertenece a este comercio";
                        break;
                    case "EC149":
                        message = "No puede realizar compras y entregas al mismo tiempo, por favor complete las ordenes pendientes.";
                        break;
                    default:
                        break;
                }
                Notification.show({
                    type: "error",
                    title: title,
                    msg: message
                });
            } else {
                Notification.show({
                    type: "error",
                    title:"Error",
                    msg: json_lang.custom_errors.provider_attach_failed
                });
            }
        });
    }
}

const updateProvider = (orderq,provider) => {
    //solo funciona con órdenes sin proveedor
    let provider_id= (typeof(provider)  === 'number') ? provider : provider[0].id;



    return (dispatch, getState) => {
		dispatch({ type: "WAIT_FOR_RESPONSE" })
		const {order, company, json_lang} = getState();

        let ordered_goods = order ? [...order.ordered_goods] : [];
        var data = ordered_goods.map((ordered_good) =>{
            return {
                ordered_good_id:ordered_good.id,
                provider_id
            }
        }).filter((ordered_good) =>{
            return ordered_good.provider_id
        });

        return axios.put(`${URL}${ company.id}/orders/${orderq || order.id}/providers`,data).then((res) => {
            Notification.show({type: "success", title: json_lang.common.success, msg: json_lang.custom_success.saved_successful});

        }).catch((err) => {
            if(err && err.data && err.data.error_code){
                const error = err.data;
                let message = error.description || error.message;
                let title = error.error_code;
                switch (error.error_code) {
                    case "ES074":
                        message = "El repartidor seleccionado no pertenece a la flota actual de la orden";
                        break;
                    case "ED202":
                    case "ED203":
                        message = "El repartidor no se encuentra en línea";
                        break;
                    case "EC318":
                        message = "Repartidor no asignable, no pertenece a este comercio";
                        break;
                    case "EC149":
                        message = "No puede realizar compras y entregas al mismo tiempo, por favor complete las ordenes pendientes.";
                        break;
                    case "EC150":
                        title = "Repartidor no asignable";
                        message = "El repartidor no posee POS asociado";
                        break;
                    case "EC151":
                        title = "Repartidor no asignable";
                        message = "El repartidor tiene órdenes activas muy lejanas a la ubicación del cliente objetivo, debe completarlas primero antes de poder asignarle más órdenes."
                        break;
                    default:
                        break;
                }
                Notification.show({
                    type: "error",
                    title: title,
                    msg: message
                });
            } else {
                Notification.show({
                    type: "error",
                    title:"Error",
                    msg: json_lang.custom_errors.provider_attach_failed
                });
            }
        });
    }
}

const updateMapProvider = (propsOrder,provider) => {
	//solo funciona con órdenes sin proveedor
    var provider_id;
    if(typeof(provider)  === 'number'){
        provider_id = provider;
    }else{
        provider_id = provider[0].id
    }
    return (dispatch, getState) => {
        dispatch({ type: "WAIT_FOR_RESPONSE" })
        let ordered_goods = propsOrder ? [...propsOrder.ordered_goods] : []
        var data = ordered_goods.map((ordered_good) =>{
            return {
                ordered_good_id:ordered_good.id,
                provider_id:provider_id
            }
        }).filter((ordered_good) =>{
            return ordered_good.provider_id
        });

        return axios.put(`${URL}${getState().company.id}/orders/${propsOrder.id}/providers`,data).then((res) => {
            Notification.show({type: "success", title:getState().json_lang.common.success, msg:getState().json_lang.custom_success.saved_successful});

        }).catch((err) => {
            Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
        });
    }
}

const removeProvider = (order,provider) => {
    return (dispatch) => {
        axios.delete(URL + store.getState().company.id + '/orders/'+ order +'/providers/'+provider)
        .then( (res) => {
            var updateOrder = store.getState().todayOrders.map( (order) => {
                if(order.id === res.data.id){
                    order = res.data;
                    var lat = parseInt(order.client_latitude_e6,10)/1000000;
                    var long =parseInt(order.client_longitude_e6,10)/1000000;
                    order.position =[lat,long]
                }
                return (order)
            })
            dispatch({
                type: 'LIST_TODAY_ORDERS',
                todayOrders: updateOrder,
            });

        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:err.title, msg:store.getState().json_lang.custom_errors.provider_attach_failed });

        });
    }
}

const unassignProviderFromTable = (order, provider) => {
    return (dispatch,getState) => {
        return axios.delete(URL + store.getState().company.id + '/orders/'+ order +'/providers/'+provider)
        .then( (res) => {

            var succesful = store.getState().json_lang.common.success
            Notification.show({type: "success", title:succesful, msg:store.getState().json_lang.custom_success.update_successful});
            res.data.touched = true;

            /*let updateTable = [...getState().orders].map( (item) => {
                if(item.id === res.data.order.id){
                    item = res.data.order
                }
                return item;
            })

            dispatch({
                type: 'FETCH_ORDERS',
                orders: updateTable
            })*/


        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:err.title, msg: store.getState().json_lang.custom_errors.provider_attach_failed });
        });
    }
}

const markAsTouched = (id, storeKey) => {
    return (dispatch, getState) => {
        let itemsList = getState()[storeKey];


        const touchedOrderIndex = itemsList.data.findIndex(order => order.id === id)
        itemsList.data[touchedOrderIndex].touched = true;

        dispatch({
            type: "TOGGLE_TOUCHED",
            storeKey: "orders",
            list: itemsList
        })
    }
}

const fetchTodayOrders = () => {
    return (dispatch, getState) => {
		const { company, json_lang, branch } = getState();
        let url_host = `/orders?sort_by=created_at,asc&limit=0&is_status_completed=0&with=client,providers`;

        if(branch && branch.id){
            url_host = `/branches/${branch.id}/orders?sort_by=created_at,asc&limit=0&is_status_completed=0&with=client,providers`;
        }

        return axios.get(`${URL+company.id}${url_host}`)
        .then( (res) => {
            let unassigned, assigned, orderedList, orders;

            orders = res.data.map( (order) => {
                let lat = parseInt(order.client_latitude_e6,10)/1000000;
                let long =parseInt(order.client_longitude_e6,10)/1000000;
                order.position =[lat,long];
                return order;
            });
            [orderedList, unassigned, assigned] = priotizeOrders("unassigned", orders);
            dispatch({
                type: 'LIST_TODAY_ORDERS',
                todayOrders: orderedList,
                ordersCounter: {"assigned": assigned, "unassigned": unassigned}
            });
            dispatch({ type: "REMOVE_LOADING" })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.retrieving_today_order_list});
        });
    }
}

const cancelOrder = (id) => {

    return (dispatch, getState) => {
		const { order,company,json_lang } = getState();
        var  data =  { reason: order && order.reason }

        /*let orderitem = [...orders]
        let o = orderitem.find(( item ) => item.id === id )
        let providers = o && o.providers;
        let client = o && o.client;*/

        dispatch({ type: "WAIT_FOR_RESPONSE"})
        return axios.post(URL + company.id + '/orders/'+id+'/set-canceled', data)
        .then( (res) => {
            res.data.touched = true;
            /*res.data.providers = providers;
            res.data.client = client;*/
            Notification.show({type: "success", title: json_lang.common.success, msg: json_lang.custom_success.update_successful});
            /*dispatch({
                type: 'FETCH_ORDERS',
                orders: tableUpdate(res, "orders"),
            });*/
        }).catch((err) => {
            dispatch({ type: "CANCEL_ORDER_ERROR", cancelOrderError: true});
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.order_cancel_failed });
        });
    }
}

export const clearCancelOrderError = () =>{
    return(dispatch) => {
        dispatch({ type: "CANCEL_ORDER_ERROR", cancelOrderError: false});
    }
}

const beingPreparedOrder = (id) => {

    return (dispatch, getState) => {
        const { order,company,json_lang } = getState();
        var  data =  { reason: order && order.reason }

        /*let orderitem = [...orders]
        let o = orderitem.find(( item ) => item.id === id )
        let providers = o && o.providers;
        let client = o && o.client;*/

        dispatch({ type: "WAIT_FOR_RESPONSE"})
        return axios.post(URL +  company.id + '/orders/'+id+'/set-being-prepared', data)
        .then( (res) => {
            Notification.show({type: "success", title: json_lang.common.success, msg: json_lang.custom_success.update_successful});
            /*
            res.data.touched = true;
            res.data.providers = providers;
            res.data.client = client;
            dispatch({
                type: 'FETCH_ORDERS',
                orders: tableUpdate(res, "orders"),
            });*/
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.order_cancel_failed });
        });
    }
}

const preparedOrder = (id) => {

    return (dispatch, getState) => {
        const { order,company,json_lang } = getState();
        var  data =  { reason: order && order.reason }

        /*let orderitem = [...orders]
        let o = orderitem.find(( item ) => item.id === id )
        let providers = o && o.providers;
        let client = o && o.client;*/

        dispatch({ type: "WAIT_FOR_RESPONSE"})
        return axios.post(`${URL +  company.id}/orders/${id}/set-prepared`, data)
        .then( (res) => {
            Notification.show({type: "success", title: json_lang.common.success, msg: json_lang.custom_success.order_canceled});

            /*res.data.touched = true;
            res.data.providers = providers;
            res.data.client = client;
            dispatch({
                type: 'FETCH_ORDERS',
                orders: tableUpdate(res, "orders"),
            });*/
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.order_cancel_failed });
        });
    }
}

const confirmationToggle = (value) => {
    return (dispatch,getState) => {
        var data = {...getState().confirmationOrder}
        data[value.name] = value.data;
        dispatch({
            type: 'CONFIRMATION_REAZON',
            confirmationOrder: data
        })
    }
}

const acceptOrderPayment = (id) => {
    return (dispatch ,getState) => {
        const { orders, json_lang, orderDetails, confirmationOrder } = getState();
        let update ={
            type: (confirmationOrder.name === "pos" || confirmationOrder.name === "efectivo") ? "post-payment" : "gateway",
            name: confirmationOrder.name,
            ref: confirmationOrder.ref
        }
        dispatch({ type: "WAIT_FOR_RESPONSE"});
        return axios.post(`${URL}${getState().company.id}/orders/${id}/set-paid`,update).then( (res) => {
            let ordersList = { ...orders };
            let newOrderDetails = {...orderDetails};
            const index = ordersList && ordersList.data && ordersList.data.findIndex(order => order.id === res.data.id) || -1;
            if(index !== -1){
                ordersList.data[index] = {
                    ...ordersList.data[index],
                    ...res.data
                };
                ordersList.data = [...ordersList.data];
                setTimeout(() => {
                    dispatch({
                        type: 'FETCH_ORDERS',
                        orders: ordersList,
                        archived_orders: []
                    });
                }, 100);
            }else if( newOrderDetails && newOrderDetails.id){
                newOrderDetails = {
                    ...newOrderDetails,
                    ...res.data
                };
                dispatch({
                    type: 'FETCH_ORDER_DETAILS',
                    orderDetails: newOrderDetails
                });
            } else {
                dispatch({ type: "REMOVE_LOADING"});
            }
            Notification.show({type: "success", title: json_lang.common.success, msg: json_lang.custom_success.saved_successful});
        }).catch((err) => {
            dispatch({ type: "REMOVE_LOADING"});
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg:json_lang.custom_errors.pament_accep });
        });
    }
}

const setOrderPublicPool = (id) => {
    return (dispatch ,getState) => {
        return axios.post(`${URL}${getState().company.id}/orders/${id}/set-public-pool`).then( (res) => {
            res.data.touched = true;
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg:getState().json_lang.custom_errors.pament_accep });
        });
    }
}

const setOrderPrivatePool = (id) => {
    return (dispatch ,getState) => {
        return axios.post(`${URL}${getState().company.id}/orders/${id}/set-private-pool`).then( (res) => {
            res.data.touched = true;
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg:getState().json_lang.custom_errors.pament_accep });
        });
    }
}

const clearPayment =()=>{
    let data={
        type: "gateway",
        name: "",
        ref: ""
    }
    return (dispatch,getState ) => {
        dispatch({
            type: 'CONFIRMATION_REAZON',
            confirmationOrder: data
        })
    }
}

const confirmOrder = (id) => {
    return (dispatch,getState ) => {
        let data = [...getState().orders]
        // let order = data.find(( item ) => item.id === id )
        /*let providers = order && order.providers;
        let client = order && order.client;*/
        return axios.post(`${URL}${getState().company.id}/orders/${id}/set-confirmed`).then( (res) => {
            /*res.data.touched = true;
            res.data.providers = providers;
            res.data.client = client;
            dispatch({
                type: 'FETCH_ORDERS',
                orders: tableUpdate(res, "orders"),
            });*/
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:err.title, msg:getState().json_lang.custom_errors.order_confirm});
        });
    }
}
const modifyInvoice = (id, type) => {
    return (dispatch,getState ) => {
        const { json_lang, company, orders, archived_orders, orderDetails } = getState();
        dispatch({ type: "WAIT_FOR_RESPONSE"});
        return axios.post(`${URL}${company.id}/orders/${id}/${type}-invoices`).then(res => {
            let ordersList = {...orders};
            let archivedOrdersList = {...archived_orders};
            let newOrderDetails = {...orderDetails};
            const index = ordersList && ordersList.data && ordersList.data.findIndex(order => order.id === res.data.id) || -1;
            const archivedIndex = archivedOrdersList && archivedOrdersList.data && archivedOrdersList.data.findIndex(order => order.id === res.data.id) || -1;
            if(index !== -1){
                ordersList.data[index] = {
                    ...ordersList.data[index],
                    ...res.data
                 };
                ordersList.data = [...ordersList.data];
                setTimeout(() => {
                    dispatch({
                        type: 'FETCH_ORDERS',
                        orders: ordersList,
                        archived_orders: []
                    });
                }, 100);
            }else if(archivedIndex !== -1){
                archivedOrdersList.data[archivedIndex] = {
                    ...archivedOrdersList.data[archivedIndex],
                    ...res.data
                };
                archivedOrdersList.data = [...archivedOrdersList.data];
                setTimeout(() => {
                    dispatch({
                        type: 'FETCH_ORDERS',
                        orders: [],
                        archived_orders: archivedOrdersList
                    });
                }, 100);

            } else if( newOrderDetails && newOrderDetails.id){
                newOrderDetails = {
                    ...newOrderDetails,
                    ...res.data
                };
                dispatch({
                    type: 'FETCH_ORDER_DETAILS',
                    orderDetails: newOrderDetails
                });
            } else {
                dispatch({ type: "REMOVE_LOADING"});
            }
            Notification.show({type: "success", title: json_lang.common.success, msg: json_lang.custom_success.saved_successful});
        }).catch((err) => {
            dispatch({ type: "REMOVE_LOADING"});
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:err.title, msg:getState().json_lang.custom_errors.order_confirm});
        });
    }
}

const adminNotes = (id, note, noteId) => {
    return (dispatch,getState ) => {
        const { company, json_lang, orderDetails } = getState();
        dispatch({ type: "WAIT_FOR_RESPONSE"});

        let adminNotes = { admin_notes: note }
        if(noteId){
            adminNotes = { ...adminNotes, admin_note_id: noteId }
        }

        return axios.patch(`${URL}${company.id}/orders/${id}`, adminNotes).then((res) => {
            if(noteId){
                dispatch({
                    type: 'FETCH_ORDER_DETAILS',
                    orderDetails: {
                        ...orderDetails,
                        ...res.data
                    },
                })
            } else{
                dispatch({ type: "REMOVE_LOADING"});
            }
            Notification.show({type: "success", title: json_lang.common.success, msg: json_lang.custom_success.saved_successful});
        }).catch((err) => {
            dispatch({ type: "REMOVE_LOADING"});
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:err.title, msg:getState().json_lang.custom_errors.order_confirm});
        });
    }
}

const addAttachment = (id, data) => {
    return (dispatch, getState) => {
        const { company, json_lang, orderDetails } = getState();
        dispatch({ type: "WAIT_FOR_RESPONSE"});
        return axios.post(`${URL}${company.id}/orders/${id}/add-attachment`, data).then((res) => {
            dispatch({
                type: 'FETCH_ORDER_DETAILS',
                orderDetails: {
                    ...orderDetails,
                    ...res.data
                },
            })
            Notification.show({type: "success", title: json_lang.common.success, msg: json_lang.custom_success.saved_successful});
        }).catch((err) => {
            dispatch({ type: "REMOVE_LOADING"});
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:err.title, msg:getState().json_lang.custom_errors.order_confirm});
        });
    }
}

const beginOrder = (id) => {
    return (dispatch,getState) => {
        let data = [...getState().orders]
        // let order = data.find(( item ) => item.id === id )
        /*let providers = order && order.providers;
        let client = order && order.client;*/
        return axios.post(`${URL + getState().company.id}/orders/${id}/set-running`).then( (res) => {
            /*res.data.touched = true;
            res.data.providers = providers;
            res.data.client = client;
            /dispatch({
                type: 'FETCH_ORDERS',
                orders: tableUpdate(res, "orders"),
            });*/
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.order_start});
        });
    }
}

const deliverOrder = (id) => {
    return (dispatch,getState) => {
        let data = [...getState().orders]
        let order = data.find(( item ) => item.id === id )
        let providers = order && order.providers;
        let client = order && order.client;
        return axios.post(`${URL}${getState().company.id}/orders/${id}/set-ready` ).then( (res) => {
            res.data.touched = true;
            res.data.providers = providers;
            res.data.client = client;
            dispatch({
                type: 'FETCH_ORDERS',
                orders: tableUpdate(res, "orders"),
            });
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.order_deliver});
        });
    }
}

const completeOrder = (id) => {
    return (dispatch,getState) => {
        axios.post(`${URL + getState().company.id}/orders/${id}/set-completed`).then( (res) => {

        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.order_complete});
        });
    }
}

const fillDashboardStatistics = () => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        const { branch} = getState();

        let thisUrl = `${URL}${getState().company.id}/order-dashboards/today`
        if(branch && branch.id){
            thisUrl = `${URL}${getState().company.id}/branches/${branch.id}/order-dashboards/today`
        }
        return axios.get(thisUrl)
        .then((res) => {
            dispatch({
                type: 'DASHBOARD',
                dashboardStatistics: res.data.payload
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: 'Falta permisos para obtener la data del dashboard'});
        });
    }
}

const fillDashboardDayStatistics = (month,year = moment().format("YYYY")) => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})

        return axios.get(`${URL}${getState().company.id}/order-dashboards/days?month=${month.replace(/^0+/, '')}&year=${year}&limit=0`).then((res) => {
            dispatch({
                type: 'DASHBOARD_DAYS',
                dashboardDaysStatistics: res
            })
        }).catch((err) => {
            if(err.message)
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
        });
    }
}

const fillDashboardMonthStatistics = (year = moment().format("YYYY")) => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})

        const { branch } = getState();

        let thisUrl = `${URL}${getState().company.id}/order-dashboards/months?year=${year}&limit=0`
        if(branch && branch.id){
            thisUrl = `${URL}${getState().company.id}/branches/${branch.id}/order-dashboards/months?year=${year}&limit=0`
        }

        return axios.get(thisUrl).then((res) => {
            dispatch({
                type: 'DASHBOARD_MONTHS',
                dashboardMonthsStatistics: res.data
            })
        }).catch((err) => {
            if(err.message)
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
        });
    }
}

const drawMonthStatistics = (month) => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})


        return axios.get(`${URL}${getState().company.id}/order-dashboards/month/${moment().format("YYYY")}-${month.replace(/^0+/, '')}`).then((res) => {
            dispatch({
                type: 'DASHBOARD_MONTHS_DATA',
                dashboardMonthsData: res.data
            })
        }).catch((err) => {

        });
    }
}

const drawMonthStatisticsID = (id) => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.get(`${URL}${getState().company.id}/order-dashboards/${id}`).then((res) => {
            dispatch({
                type: 'DASHBOARD_MONTHS_DATA',
                dashboardMonthsData: res.data.payload
            })
        }).catch((err) => {
           //console.log("El mes "+month+" No tiene data")
        });
    }
}

const drawDasboard =(month,year = moment().format("YYYY"))=> {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        let urlArray = [
            `${URL}${getState().company.id}/order-dashboards/today`,//today
            `${URL}${getState().company.id}/order-dashboards/days?month=${month}&year=${year}&limit=0`,//dias en el mes x q tienen ordenes
            `${URL}${getState().company.id}/order-dashboards/month/${year}-${month}`,//today
            `${URL}${getState().company.id}/order-dashboards/months?year=${year}&limit=0`
        ]

        let promiseArray = urlArray.map(url => axios.get(url));
        Promise.all(promiseArray).then(function(res) {
            /*let temp = res.map(r => r.data);
            dispatch({
                type: 'DASHBOARD_MONTHS_DATA',
                dashboardMonthsData: res.data
            })*/
        });
    }
}

const newStadistic = (id) => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.get(`${URL}${getState().company.id}/order-dashboards/${id}`).then((res) => {
            dispatch({
                type: 'DASHBOARD_DAYS_UPDATE',
                orderPast: res.data.payload
            })
        }).catch((err) => {
           //console.log("El mes "+month+" No tiene data")
        });
    }
}

const fetchOrderForms = (id) => {
    return (dispatch,getState) => {
        return axios.get(URL +getState().company.id + '/orders/'+id+'/payments?with=admin')
        .then( (res) => {
            res.data.sort(function (a, b) {
              if (a.id > b.id) {//ordena los ids de mayor a menor
                return -1;
              }
              if (a.id < b.id) {
                return 1;
              }
              return 0;
            })
            dispatch({
                type: 'GET_PAYMENT_FORM',
                payment_form:res.data
            })
        }).catch((err) => {
            if(err.message)
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
        });
    }
}

const fetchOrderCancelationReason = (id) => {
    return (dispatch,getState) => {
        return axios.get(`${URL}${getState().company.id}/orders/${id}/cancellation-reason`).then( (res) => {
            dispatch({
                type: 'GET_CANCELATION_REASON',
                cancelationReason:res.data
            })
        }).catch((err) => {
            if(err.message)
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
        });
    }
}

const fetchOrderBids = (id) => {
    return (dispatch,getState) => {
        // dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.get(`${URL}${getState().company.id}/orders/${id}/bids?limit=0&with=provider`).then( (res) => {
            dispatch({
                type: 'GET_BIDS',
                bids:res.data
            })
        }).catch((err) => {
            /*if(err.message)
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});*/
        });
    }
}

const confirmOrderBid = (id) => {
    return (dispatch,getState) => {
        return axios.post(`${URL}${getState().company.id}/bids/${id}/confirm`).then( (res) => {
            //let order = getState().order;
            Notification.show({ type: "success", title: getState().json_lang.common.success, msg:getState().json_lang.custom_success.update_successful });
            /*order = {
                ...order,
            ...res.data
            }

            dispatch({
                type: 'UPDATE_BIDS',
                bids: [],
                orderDetails:order
            })*/
            dispatch({
                type: "ERROR_BIDS",
                errorBids: false
            });
        }).catch((err) => {
            dispatch({
                type: "ERROR_BIDS",
                errorBids: true
            });
            if(err.data){
                if (err.data.message === "not_allowed"){
                    Notification.show({type: "error", title: "Pago pendiente", msg: "Debe confirmar el pago"});
                }
                if(err.data.error_code === "ED203"){
                    Notification.show({type: "error", title: "Repartidor Offline", msg: "El repartidor no está en línea"});
                    return "ED203"
                }
            } else {
                Notification.show({type: "error", title:`Error`, msg: "Ha ocurrido un error inesperado"});
            }
        });
    }
}

const cancelOrderBid = (id) => {
    return (dispatch,getState) => {
        const bid_id = id;
        return axios.post(`${URL}${getState().company.id}/bids/${id}/cancel`).then( (res) => {
            let order = getState().order;
            order = {
                ...order,
                ...res.data
            }
            let bids = getState().bids.filter(elm => elm.id !== bid_id);
            dispatch({
                type: 'UPDATE_BIDS',
                orderDetails:order,
                bids
            })
        }).catch((err) => {
            if (err.data.message === "not_allowed")
                Notification.show({type: "error", title: "Pago pendiente", msg: "Debe confirmar el pago"});
            else if(err.message)
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
        });
    }
}

const  preloadOrderCart = () => {
    return (dispatch,getState) => {
        var preloadOrder = getState().order
        var cart = getState().cart
        cart.client_address = preloadOrder.client_address
        cart.client_latitude_e6 = preloadOrder.client_latitude_e6
        cart.client_longitude_e6 = preloadOrder.client_longitude_e6
        cart.isPickup= parseInt(preloadOrder.client_latitude_e6, 10) === 0 && parseInt(preloadOrder.client_longitude_e6, 10) === 0 && preloadOrder.client_address === null? true : false ;
        cart.notes = preloadOrder.notes !== null ? preloadOrder.notes : ''
        cart.scheduled_at = preloadOrder.scheduled_at !== null ? preloadOrder.scheduled_at : ''

        dispatch({
            type: 'BUILD_ORDER',
            cart: cart
        })
    }
}

const clearCart = () => {
    return (dispatch) => {
        dispatch({
            type: 'CLEAR_CART'
        });
    }
}

const clearBids = () => {
    return (dispatch) => {
        dispatch({
            type: 'CLEAR_BIDS',
        })
    }
}

const filterOrdersAssigned = () => {
    return (dispatch, getState) => {
        let assginedAddedOrders = [],
            mapFilters = getState().mapFilters,
            filteredMapOrders = [...getState().filteredMapOrders],
            mapOrders = [...getState().mapOrders];

        mapOrders.forEach(order => {
            if (order.provider_id) {
                assginedAddedOrders.push(order);
            }
        });

        dispatch({
            type: "FETCH_MAP_ORDERS",
            filteredMapOrders: mapFilters.assigned ?
                mergeArrays([...filteredMapOrders, ...assginedAddedOrders]) :
                removeFromArray([...filteredMapOrders], [...assginedAddedOrders])
        })
    }
}

const filterOrdersUnassigned = () => {
    return (dispatch, getState) => {
        let unassginedAddedOrders = [],
            mapFilters = getState().mapFilters,
            filteredMapOrders = [...getState().filteredMapOrders],
            mapOrders = [...getState().mapOrders];




        mapOrders.forEach(order => {
            if (!order.provider_id) {
                unassginedAddedOrders.push(order);
            }
        });

        dispatch({
            type: "FETCH_MAP_ORDERS",
            filteredMapOrders: mapFilters.unassigned ?
                mergeArrays([...filteredMapOrders, ...unassginedAddedOrders]) :
                removeFromArray([...filteredMapOrders], [...unassginedAddedOrders])
        })
    }
}

const filterOrdersInsideDateRange = () => {
    return (dispatch, getState) => {
        let mapOrders = [],
            filteredMapOrders = getState().filteredMapOrders,
            dateFilter = getState().mapFilters.date;

        // Obtener fechas base usando Date nativo
        const today = new Date();

        // Funciones auxiliares para validación y conversión de fechas
        const isValidDate = (dateString) => {
            if (!dateString) return false;
            const date = new Date(dateString);
            return date instanceof Date && !isNaN(date);
        };

        const parseDate = (dateString) => {
            if (!dateString) return null;
            const date = new Date(dateString);
            return isNaN(date) ? null : date;
        };

        // Función para determinar si una fecha está dentro del rango permitido
        const isWithinAllowedRange = (date, filterType) => {
            if (!date) return false;

            const today = new Date();
            const startOfMonth = new Date(
                today.getFullYear(),
                today.getMonth(),
                1
            );
            const fiveDaysAgo = new Date(
                today.getTime() - 5 * 24 * 60 * 60 * 1000
            );

            switch (filterType) {
                case "day":
                    return date.toDateString() === today.toDateString();
                case "week":
                    const startOfWeek = new Date(
                        today.getFullYear(),
                        today.getMonth(),
                        today.getDate() - today.getDay()
                    );
                    const endOfWeek = new Date(
                        today.getFullYear(),
                        today.getMonth(),
                        today.getDate() + (6 - today.getDay())
                    );
                    return date >= startOfWeek && date <= endOfWeek;
                case "month":
                    return (
                        (date >= startOfMonth && date <= today) ||
                        (date >= fiveDaysAgo && date < startOfMonth)
                    );
                default:
                    return false;
            }
        };

        // Filtrar órdenes según los criterios establecidos
        filteredMapOrders.forEach((order) => {
            let orderDate = null;

            // Priorizar scheduled_at si existe
            if (order.scheduled_at) {
                const scheduledDate = parseDate(
                    order.scheduled_at.split(" ")[0]
                );
                if (isValidDate(scheduledDate)) {
                    orderDate = scheduledDate;
                }
            }

            // Usar created_at si scheduled_at no es válido
            if (!orderDate && order.created_at) {
                const createdDate = parseDate(order.created_at.split(" ")[0]);
                if (isValidDate(createdDate)) {
                    orderDate = createdDate;
                }
            }

            // Verificar si la orden cumple con el filtro seleccionado
            if (orderDate) {
                switch (true) {
                    case dateFilter.todayOrders:
                        if (isWithinAllowedRange(orderDate, "day")) {
                            mapOrders.push(order);
                        }
                        break;
                    case dateFilter.thisWeekOrders:
                        if (isWithinAllowedRange(orderDate, "week")) {
                            mapOrders.push(order);
                        }
                        break;
                    case dateFilter.thisMonthOrders:
                        if (isWithinAllowedRange(orderDate, "month")) {
                            mapOrders.push(order);
                        }
                        break;
                }
            }
        });

        dispatch({
            type: "FETCH_MAP_ORDERS",
            filteredMapOrders: [...mapOrders],
        });
    };
};

const filterOrderByStatus = () => {
    return (dispatch, getState) => {
        let mapOrders = [],
            mapFilters = getState().mapFilters,
            filteredMapOrders = getState().filteredMapOrders;

        // guarda las que esten activas segun el filtro indicados en mapfilters
        filteredMapOrders.forEach(order => {
            const algo = orderStatus(order.status, true) // filters in map are always fordelivery so second parameter its always true
            if ( orderHasFlag( algo.step, mapFilters) ) {
                mapOrders.push(order);
            }
        })

        dispatch({
            type: "FETCH_MAP_ORDERS",
            filteredMapOrders: [...mapOrders]
        })
    }
}

const clearMapFilters = () => {
    return {
        type: "CLEAR_MAP_FILTERS"
    }
}



const fetchMapOrders = (limit= 10, filter_query = '') => {
    return (dispatch, getState) => {
		dispatch({ type: "WAIT_FOR_RESPONSE" })
		const { company, branch, userHigherAccess } = getState();

		let url_host = `${URL + company.id}/branches/${branch.id}/orders?with=client,orderProviders.provider&limit=${limit}`;


		if (userHigherAccess === COMPANY_ACCESS && !branch.name) {
			url_host = URL + company.id + '/orders?with=client,orderProviders.provider&limit=' + limit
		}
        url_host += filter_query !== "" ? "&" + filter_query : "";
        return axios.get(url_host).then((res) => {

            let deliveryOrders = [];
            // busco todos las ordenes tipo delivery
            const data = limit===0 ? res.data : res.data.data
            data.forEach(order => {
                if (!isPickUp(order.client_latitude_e6, order.client_longitude_e6, order.client_address)) {
                    deliveryOrders.push(order);
                }
            })

            delete res.data.data;
            
            dispatch({
                type: 'FETCH_MAP_ORDERS',
                mapOrders: deliveryOrders,
                filteredMapOrders: deliveryOrders,
                //!paginationOrders: res.data
            })
        }).catch((err) => {
            var dataError = Errors(err);
            dispatch({
                type: 'ERROR',
                errors: dataError
            })
        });
    }
}

const dataAsignableOrderParse =(orderID)=> {
    return (dispatch, getState) => {
        let orders = [...getState().orders];
        let selected_order = orders.find( (order,key) => { return order.id === orderID })
        return selected_order
    }
}


const toogleAssingProvider = (provider,assignedGood) => {
    return (dispatch, getState) => {
        //let goods = [assignedGood];
        let order ={...getState().order}

        let rck= order.ordered_goods.map((ordered_good) =>{
            if(ordered_good.id === assignedGood){
                ordered_good.assigned_provider = provider.id
            }
            return ordered_good
        });
        order.ordered_goods = rck

        dispatch({
            type: 'FETCH_ORDER',
            order: order
        })

    }
}

const assigMultiProvider = (orderId) => {
    return (dispatch, getState) => {
		dispatch({ type: "WAIT_FOR_RESPONSE" })
		const {order, company, json_lang} = getState();
        //let goods = [assignedGood];
        let ordered_goods = order ? [...order.ordered_goods] : [];
        var data = ordered_goods.map((ordered_good) =>{
            return {
                ordered_good_id:ordered_good.id,
                provider_id:ordered_good.assigned_provider
            }
        }).filter((ordered_good) =>{
            return ordered_good.provider_id
        });

        return axios.put(`${URL}${ company.id}/orders/${orderId}/providers`,data).then((res) => {


            /* dispatch({ type: "REMOVE_LOADING" })

            var allorder = todayOrders.map( (order) => {
                if (order.id === res.data.id) {
                    order.provider = res.data.providers;
                }
                order.position =[
                    parseInt(parseInt(order.client_latitude_e6,10)/1000000,10),
                    parseInt(parseInt(order.client_longitude_e6,10)/1000000,10)
                ]
                return (order)
            })

            dispatch({
                type: 'UPDATE_TODAY_ORDERS',
                todayOrders: allorder,
                orders: tableUpdate(res, "orders")
            }); */
            Notification.show({type: "success", title: json_lang.common.success, msg: json_lang.custom_success.saved_successful});

        }).catch((err) => {
            Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
        });
    }
}

const editQuantity = (quantity,key) => {
    return (dispatch, getState) => {
        var cart = { ...getState().cart };

        cart.goods[key].quantity = quantity;
        cart.goods[key].total_price_e2 = cart.goods[key].price_e2 * cart.goods[key].quantity;//cart.goods[key].total_price_e2 +;

        cart.goods[key].properties.map( (goodProprerty,propKey ) => {
            goodProprerty.price =  goodProprerty.temp_base_price * cart.goods[key].quantity;
            var multiOptionInputs = goodProprerty.type === 'checkbox' || goodProprerty.type === 'select-one' || goodProprerty.type === 'radio';
            var idReference = multiOptionInputs ? goodProprerty.value+'-'+goodProprerty.property_id : goodProprerty.property_id;

            cart.propertiesQuantity.map( (pQuantity,key ) => {
                if(pQuantity.id === idReference){
                    pQuantity.quantity = goodProprerty.type === 'range' ? parseInt(goodProprerty.value,10) * quantity : quantity
                }
                return pQuantity
            })

            return goodProprerty
        })

        cart.goodsQuantity.map( (goodQuantity,key ) => {
            if(goodQuantity.id === cart.goods[key].id ){
                goodQuantity.quantity=quantity
            }
            return goodQuantity
        })
        dispatch({
            type: 'BUILD_ORDER',
            cart: cart
        })
    }
}

const getTimelineOrder = (orderId) => {
    return (dispatch, getState) => {
        const { company/*, json_lang, branch*/} = getState();
        return axios.get(`${URL+company.id}/orders/${orderId}/order-histories`).then((res) => {
            dispatch({
                type: 'FETCH_TIMELINEORDER',
                timelineOrder: res.data
            })
        }).catch((err) => {
			dispatch({
				type: 'REMOVE_LOADING'
			});
           /* Notification.show({
                type: "error",
                title:`Error ${err && err.data && err.data.error_code}`,
                msg: err.message && err.message !== 'generic' ? err.message : json_lang.custom_errors.retrieving_user_list
            });*/
        });
    }
}

const fetchOrdersByStatus = (MASK,VALUE) => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        const { company, userHigherAccess, branch } = getState();

        let url_host = `${URL+company.id}/branches/${branch.id}/orders?status=flag ${MASK},${VALUE}&with=orderProviders.provider,client,creator&limit=0`;
        if (userHigherAccess === COMPANY_ACCESS && !branch.name){
            url_host = `${URL+company.id}/orders?status=flag ${MASK},${VALUE}&with=orderProviders.provider,client,branch,creator&limit=0`
        }




        return axios.get(url_host).then( (res) => {
                /// if user tipe 2 mostrar solo ordenes pagadas

            dispatch({
                type: 'FETCH_ORDERS',
                orders: res.data,
                archived_orders: []
            })
        }).catch((err) => {
            var dataError = Errors(err);
            dispatch({
                type: 'ERROR',
                errors: dataError
            });
        });
    }
}

const resendPool = (id) => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        const { company, json_lang } = getState();

        return axios.post(`${URL+company.id}/orders/${id}/send-to-pool`,{ force: true }).then( () => {
            Notification.show({ type: "success", title: json_lang.common.success, msg:json_lang.custom_success.resend_pool_successful });


        }).catch((err) => {
            Notification.show({
                type: "error",
                title:`Error ${err && err.data && err.data.error_code}`,
                msg: err.message && err.message !== 'generic'? err.message : err.data.message
            });
        });
    }
}

const orderGiveChange = (data, orderId) => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"});
        dispatch({
            type: 'GIVE_CHANGE_ERROR',
            giveChangeError: false
        });

        const { company,json_lang } = getState();

        return axios.post(`${URL+company.id}/orders/${orderId}/balance-movements/give-change`, data).then((res) => {
            Notification.show({ type: "success", title: json_lang.common.success, msg:json_lang.custom_success.givechange_successful });
            dispatch({
                type: 'FETCH_GIVE_CHANGE',
                giveChange: res.data
            })
        }).catch((err) => {
            dispatch({
                type: 'GIVE_CHANGE_ERROR',
                giveChangeError: true
            });
            dispatch({type: "REMOVE_LOADING"});
            if(err && err.data){
                const error = localizedErrorHandler(err.data);
                switch(error.code){
                    case "EF504": {
                        let message = error.message
                        const regex = /amount_e2 \((\d+)\).*order amount \((\d+)\)/;
                        const match = message.match(regex);
                        if (match) {
                            const totalAmount = Number(match[1]);
                            const orderAmount = Number(match[2]);
                            message = `El monto total (${number_format(totalAmount / 100)}) no puede ser mayor que el monto de la orden (${number_format(orderAmount / 100)}).`;
                        }
                        Notification.show({
                            type: "error",
                            title: `Error: ${error.code}`,
                            msg: message
                        });
                        break;
                    }
                    default:{
                        Notification.show({
                            type: "error",
                            title: `Error: ${error.code}`,
                            msg: error.message
                        });
                        break;
                    }
                }
            } else {
                Notification.show({
                    type: "error",
                    title: "Error",
                    msg: json_lang.two_steps_modal.default_error
                });
            }
        });
    }
}

const orderpParcialGivechange = () => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})

        const { company, parcialGivechange,orderDetails,json_lang } = getState();

        let amount = parseFloat(FloatPrecision(parcialGivechange.amount_e2.replace(',','.')))*100;
        if(parcialGivechange.add === 'remove'){
            amount = amount *-1
        }


        parcialGivechange.amount_e2 =  amount
        parcialGivechange.adjust_client_balance = (parcialGivechange.adjust_client_balance === null|| parcialGivechange.adjust_client_balance === false) ? false : true
        return axios.post(`${URL+company.id}/orders/${orderDetails.id}/adjust`,parcialGivechange).then( (res) => {
            Notification.show({ type: "success", title: json_lang.common.success, msg:json_lang.custom_success.edit_order_successful });


        }).catch((err) => {
            Notification.show({
                type: "error",
                title:`Error ${err && err.data && err.data.error_code}`,
                msg: err.message && err.message !== 'generic'? err.message : err.data.message
            });
        });
    }
}
const toogleOrdeParcialGiveChange = (value) => {
    return (dispatch,getState) => {
        var data = {...getState().parcialGivechange}
        data[value.name] = value.name === 'adjust_client_balance' ? value.checked : value.data;
        dispatch({
            type: 'FETCH_PARTIAL_GIVE_CHANGE',
            parcialGivechange: data
        })
    }
}
const toogleOrderGiveChange = (value) => {
    return (dispatch,getState) => {
        var data = {...getState().giveChange}

        data[value.name] = value.name === 'adjust_provider_balance' ? value.checked : value.data;

        dispatch({
            type: 'FETCH_GIVE_CHANGE',
            giveChange: data
        })
    }
}
const clearOrderParcialGivechange = (value) => {
    return (dispatch,getState) => {
        let data = {
            amount_e2:'',
            description:'',
            adjust_client_balance:false,
            add:"add"
        }
        dispatch({
            type: 'FETCH_PARTIAL_GIVE_CHANGE',
            parcialGivechange:data,
        })
    }
}
const clearOrderGiveChange = (value) => {
    return (dispatch,getState) => {
        var data ={
            amount_e2:'',
            description:''
        }
        dispatch({
            type: 'FETCH_GIVE_CHANGE',
            giveChange: data
        })
    }
}

const fetchHistoryGivechange = (orderId) => {
    return (dispatch, getState) => {
       return axios.get(`${URL+getState().company.id}/orders/${orderId}/balance-movements?type=:in:change,refund,adjustment&with=author.admin,owner`).then((res) => {
            dispatch({
                type: 'FETCH_GIVE_CHANGE_HISTORY',
                giveChangeHistory: res.data
            })
        }).catch((err) => {
            console.log("FETCH_ARCHIVED_ORDERS",err)

            dispatch({
                type: 'ERROR',
                errors: ""
            });
        });
    }
}

const changeStatusOrderProvider = (orderProviderId,status,ProofCode) => {
    return (dispatch, getState) => {
        let data;
        if(ProofCode){
            data ={
                code:ProofCode
            }
        }
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.post(`${URL+getState().company.id}/order-providers/${orderProviderId}/set-${status}`,data).then((res) => {
            dispatch({type: "REMOVE_LOADING"})
            Notification.show({
                type: "success",
                msg: `Estatus modificado con éxito`
            });


        }).catch((err) => {
            dispatch({type: "REMOVE_LOADING"})
            if(err && err.data && err.data.error_code){
                const error = err.data;
                switch(error.error_code){
                    case "EC104":
                        Notification.show({
                            type: "error",
                            title:`Error ${error.error_code}: Pago no válido`,
                            msg: "La orden no posee un pago válido"
                        });
                        break;
                    case "EC127":
                        Notification.show({
                            type: "error",
                            title:`Error ${error.error_code}: Orden no preparada`,
                            msg: "La orden aún no se encuentra preparada. Por favor comuníquese con el comercio"
                        });
                        break;
                    default:
                        Notification.show({
                            type: "error",
                            title:`Error ${error.error_code}`,
                            msg: `Ocurrió un error inesperado al actualizar el estatus de la orden con mensaje: ${error.description}`
                        });
                        break;
                }
            } else {
                Notification.show({
                    type: "error",
                    title:`Error`,
                    msg: "Ocurrió un error inesperado al actualizar el estatus de la orden"
                });
            }
        });
    }
}

const fetchOrdersBranchHeatmap = () => {
    return (dispatch,getState) => {
        const { company } = getState();
        dispatch({ type: 'WAIT_FOR_RESPONSE'});
        return axios.get(`${URL + company.id}/orders/branch-heatmap`).then(res => {
            dispatch({
                type: 'FETCH_ORDERS_HEATMAP',
                ordersBranchHeatmap: res.data
            });
        }).catch((err) => {
            dispatch({ type: "REMOVE_LOADING" });
        });
    }
}

export const fetchShopperChats  = (id) => {
    return (dispatch,getState) => {
		const { company } = getState();
        dispatch({ type: 'WAIT_FOR_RESPONSE'});
            return axios.get(`${URL + company.id}/order-providers/${id}/chat-messages?limit=0&sort_by=id,asc`).then(res => {
                dispatch({
                    type: 'FETCH_SHOPPER_CHATS',
                    shopperChats: res.data
                });
            }).catch((err) => {
                dispatch({ type: 'REMOVE_LOADING'});
                if(err.message && err.message !== 'generic')
                    switch(err && err.data && err.data.error_code){
                        case 'ER404':
                            break;
                        default:
                            Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: `Error al cargar los datos del chat con el shopper con mensaje: ${err.data.description}` });
                            break;
                    }
                else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: "Error al cargar los datos del chat con el shopper" });
        });
    }
}

export const fetchProviderChats  = (id) => {
    return (dispatch,getState) => {
		const { company } = getState();
        dispatch({ type: 'WAIT_FOR_RESPONSE'});
            return axios.get(`${URL + company.id}/order-providers/${id}/chat-messages?limit=0&sort_by=id,asc`).then(res => {
                dispatch({
                    type: 'FETCH_PROVIDER_CHATS',
                    providerChats: res.data
                });
            }).catch((err) => {
                dispatch({ type: 'REMOVE_LOADING'});
                if(err.message && err.message !== 'generic')
                    switch(err && err.data && err.data.error_code){
                        case 'ER404':
                            break;
                        default:
                            Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: `Error al cargar los datos del chat con el repartidor con mensaje: ${err.data.description}` });
                            break;
                    }
                else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: "Error al cargar los datos del chat con el repartidor" });
        });
    }
}

export const clearChats = () => {
    return (dispatch) => {
        dispatch({
            type: 'FETCH_PROVIDER_CHATS',
            providerChats: []
        });
        dispatch({
            type: 'FETCH_SHOPPER_CHATS',
            shopperChats: []
        });
    }
}

export const getOrderFleets = (orderId) => {
    return (dispatch, getState) => {
        const { company } = getState();
        return axios.get(`${URL + company.id}/orders/${orderId}/available-fleets`).then((res) => {
            dispatch({
                type: 'GET_ORDER_FLEETS',
                orderFleets: res.data
            });
        }).catch((err) => {
            Notification.show({
                type: "error",
                title:`Error ${err && err.data && err.data.error_code}`,
                msg: `Error al cargar las flotas de la orden con mensaje: ${err.description}` });
        });
    }
}

export const setOrderFleet = (orderId, id) => {
    return (dispatch, getState) => {
        const { company } = getState();
        dispatch({ type: 'WAIT_FOR_RESPONSE'});
        return axios.post(`${URL + company.id}/orders/${orderId}/set-selected-fleet`, { service_charge_id: id }).then((res) => {
            dispatch({
                type: 'FETCH_ORDER',
                order: res.data
            })
        }).catch((err) => {
            dispatch({ type: 'REMOVE_LOADING'});
            if(err && err.data && err.data.error_code){
                const error = err.data;
                let message = error.description || error.message;
                let title = error.error_code;
                switch (error.error_code) {
                    case "EC241":
                        message = "No se puede asignar flota debido a restricciones de pago";
                        break;
                    default:
                        break;
                }
                Notification.show({
                    type: "error",
                    title: title,
                    msg: message
                });
            } else {
                Notification.show({
                    type: "error",
                    title:"Error",
                    msg: "Ha ocurrido un error inesperado"
                });
            }
        });
    }
}

export const clearProviderOrders = () => {
    return (dispatch) => {
        dispatch({
            type: 'FETCH_PROVIDER_ORDERS',
            providerOrders: []
        })
    }
}

export const recreateOrder = (id, cartId, client) => {
    return (dispatch, getState) => {
        const { company } = getState();
        dispatch({
            type: "FETCH_CLIENT",
            client: client
        });
        const body = {
            order_id: id,
        }
        return axios.post(`${URL + company.id}/carts/${cartId}/replace-items-from-order`, body)
            .catch((err) => {
                const error = localizedErrorHandler(err.data);
                Notification.show({
                    type: "error",
                    title: error.title,
                    msg: error.description
                });
                dispatch({
                    type: 'ERROR_ON_RECREATE_ORDER',
                    errorOnRecreateOrder: error
                });
            })
    }
}

export const clearErrorOnRecreateOrder = () => {
    return (dispatch) => {
        dispatch({
            type: 'ERROR_ON_RECREATE_ORDER',
            errorOnRecreateOrder: null
        });
    }
}

// EDIT ORDER ENDPOINTS

export const getOrderedGood = (branchId,goodId) => {
    return (dispatch, getState) => {
        const { company } = getState();
        return axios.get(`${URL + company.id}/branches/${branchId}/goods/${goodId}?limit=0&with=materials,branch_good_properties&include_weight_unit_compat=1`).then((res) => {
            dispatch({
                type: 'GET_ORDERED_GOOD',
                orderedGood: res.data
            });
        }).catch((err) => {
            if(err && err.data){

                Notification.show({
                    type: "error",
                    title:`Error ${err.data.error_code}`,
                    msg: `Error al cargar el producto de la orden con mensaje: ${err.description}` });
            } else {
                Notification.show({
                    type: "error",
                    title:`Error`,
                    msg: `Error al cargar el producto de la orden` });
            }
        });
    }
}

export const addOrderedGood = (orderId, body) => {
    return (dispatch, getState) => {
        const { company, orderDetails } = getState();
        dispatch({ type: "WAIT_FOR_RESPONSE" });
        return axios.post(`${URL + company.id}/orders/${orderId}/ordered-goods`, body).then((res) => {
            dispatch({
                type: 'FETCH_ORDER_DETAILS',
                orderDetails: {
                    ...orderDetails,
                    ...res.data.order
                },
            });
        }).catch((err) => {
            dispatch({ type: 'ERROR_ON_ORDERED_GOOD', errorOnOrderedGood: true});
            if(err && err.data){
                const error = err.data;
                switch(error.error_code){
                    case "EC215":
                        if(error.localized_error && error.localized_error.spanish){
                            Notification.show({
                                type: "error",
                                title:`Error ${error.error_code}`,
                                msg: `${error.localized_error.spanish.message}`
                            });
                        } else {
                            Notification.show({
                                type: "error",
                                title:`Error ${error.error_code}`,
                                msg: `Error al agregar producto con mensaje: ${error.description}`
                            });
                        }
                        break;
                    default:
                        if(error.localized_error && error.localized_error.spanish){
                            Notification.show({
                                type: "error",
                                title:`Error ${error.error_code}`,
                                msg: `${error.localized_error.spanish.message}`
                            });
                        } else {
                            Notification.show({
                                type: "error",
                                title:`Error ${error.error_code}`,
                                msg: `Error al agregar producto con mensaje: ${error.description}`
                            });
                        }
                        break;
                }
            }
        });
    }
}

export const editOrderedGood = (orderId, goodId, body) => {
    return (dispatch, getState) => {
        const { company, orderDetails } = getState();
        dispatch({ type: "WAIT_FOR_RESPONSE" });
        return axios.patch(`${URL + company.id}/orders/${orderId}/ordered-goods/${goodId}`, body).then((res) => {
            dispatch({
                type: 'FETCH_ORDER_DETAILS',
                orderDetails: {
                    ...orderDetails,
                    ...res.data.order
                },
            });
        }).catch((err) => {
            dispatch({ type: 'ERROR_ON_ORDERED_GOOD', errorOnOrderedGood: true});
            if(err && err.data){
                const error = err.data;
                switch(error.error_code){
                    case "EC215":
                        if(error.localized_error && error.localized_error.spanish){
                            Notification.show({
                                type: "error",
                                title:`Error ${error.error_code}`,
                                msg: `${error.localized_error.spanish.message}`
                            });
                        } else {
                            Notification.show({
                                type: "error",
                                title:`Error ${error.error_code}`,
                                msg: `Error al modificar producto con mensaje: ${error.description}`
                            });
                        }
                        break;
                    default:
                        Notification.show({
                            type: "error",
                            title:`Error ${error.error_code}`,
                            msg: `Error al modificar producto con mensaje: ${error.description}`
                        });
                        break;
                }
            }
        });
    }
}

export const deleteOrderedGood = (orderId, goodId) => {
    return (dispatch, getState) => {
        const { company, orderDetails } = getState();
        dispatch({ type: "WAIT_FOR_RESPONSE" });
        return axios.delete(`${URL + company.id}/orders/${orderId}/ordered-goods/${goodId}`).then((res) => {
            dispatch({
                type: 'FETCH_ORDER_DETAILS',
                orderDetails: {
                    ...orderDetails,
                    ...res.data.order
                },
            });
        }).catch((err) => {
            dispatch({ type: 'ERROR_ON_ORDERED_GOOD', errorOnOrderedGood: true});
            if(err && err.data){
                Notification.show({
                    type: "error",
                    title:`Error ${err.data.error_code}`,
                    msg: `Error al eliminar producto con mensaje: ${err.data.description}` });
            }
        });
    }
}

export const fetchOrderHistory = (orderId) => {
    return (dispatch, getState) => {
        const { company } = getState();
        return axios.get(`${URL + company.id}/orders/${orderId}/ordered-goods/history`).then((res) => {
            dispatch({
                type: 'FETCH_ORDER_HISTORY',
                orderHistory: {
                    ...res.data
                },
            });
        }).catch((err) => {
            if(err && err.data){
                dispatch({
                    type: "ORDER_HISTORY_ERROR",
                    orderHistoryError: {
                        error: {
                            ...err.data
                        }
                    }
                });
                Notification.show({
                    type: "error",
                    title:`Error ${err.data.error_code}`,
                    msg: `Error al cargar historial con mensaje: ${err.data.description}` 
                });
            }
        });
    }
}

export const clearOrderHistory= () => {
    return (dispatch) => {
        dispatch({
            type: 'FETCH_ORDER_HISTORY',
            orderHistory: {
                history: [],
                original_data: null
            }
        });
    }
}

export const clearOrderHistoryError = () => {
    return (dispatch) => {
        dispatch({ type: 'ORDER_HISTORY_ERROR', orderHistoryError: { error: null }});
    }
}

export const clearOrderedGood = () => {
    return (dispatch) => {
        dispatch({
            type: 'GET_ORDERED_GOOD',
            orderedGood: {}
        });
    }
}

export const clearErrorOnOrderedGood = () => {
    return (dispatch) => {
        dispatch({ type: 'ERROR_ON_ORDERED_GOOD', errorOnOrderedGood: false});
    }
}

export const getClientCarts = (clientId) => {
    return (dispatch, getState) => {
        const { company, branch } = getState();
        return axios.get(`${URL + company.id}/clients/${clientId}/branches/${branch.id}/carts?with=branch`).then((res) => {
            res.data.items.forEach(item => {
                item.quantity_real = item.quantity;
            });
            dispatch({
                type: 'GET_CLIENT_CART',
                cart: res.data,
                errorOnCart: false
            });
        }).catch((err) => {
            if(err && err.data){
                // dispatch({
                //     type: "CLIENT_CARTS_ERROR",
                //     clientCartsError: {
                //         error: {
                //             ...err.data
                //         }
                //     }
                // });
                Notification.show({
                    type: "error",
                    title:`Error ${err.data.error_code}`,
                    msg: `Error al cargar carritos con mensaje: ${err.data.description}` 
                });
            }
        });
    }
}

export const updateCart = (body) => {
    return (dispatch, getState) => {
        const { company, cart } = getState();
        return axios.patch(`${URL + company.id}/carts/${cart.id}`, body).then((res) => {
            if(res.data.payment_info.is_balance_in_use && res.data.resume.fees.available_balance.amount_e2 <= 0){
                return axios.patch(`${URL + company.id}/carts/${cart.id}`, {
                    payment_info: {
                        ...res.data.payment_info,
                        is_balance_in_use: false
                    }
                }).then((res) => {
                    res.data.items.forEach(item => {
                        item.quantity_real = item.quantity;
                    });
                    Notification.show({
                        type: "warning",
                        title:`Balance insuficiente.`,
                        msg: `El balance disponible es insuficiente, por lo que no es posible aplicar los ZupperCredits` 
                    });
                    dispatch({
                        type: 'GET_CLIENT_CART',
                        cart: res.data,
                        errorOnCart: false
                    });
                }).catch((err) => {
                    dispatch({
                        type: 'GET_CLIENT_CART',
                        cart: { ...cart },
                        errorOnCart: true
                    });
                    if(err && err.data){
                        Notification.show({
                            type: "error",
                            title:`Error ${err.data.error_code}`,
                            msg: `Error al cargar carritos con mensaje: ${err.data.description}` 
                        });
                    }
                });
            } else {
                res.data.items.forEach(item => {
                    item.quantity_real = item.quantity;
                });
                dispatch({
                    type: 'GET_CLIENT_CART',
                    cart: res.data,
                    errorOnCart: false
                });
            }
        }).catch((err) => {
            dispatch({
                type: 'GET_CLIENT_CART',
                cart: { ...cart },
                errorOnCart: true
            });
            if(err && err.data){
                Notification.show({
                    type: "error",
                    title:`Error ${err.data.error_code}`,
                    msg: `Error al cargar carritos con mensaje: ${err.data.description}` 
                });
            }
        });
    }
}

export const addItemToCart = (body) => {
    return (dispatch, getState) => {
        const { company, cart } = getState();
        
        return axios.post(`${URL + company.id}/carts/${cart.id}/cart-items`, body).then((res) => {
            res.data.items.forEach(item => {
                item.quantity_real = item.quantity;
            });
            dispatch({
                type: 'GET_CLIENT_CART',
                cart: res.data,
                errorOnCart: false
            });
        }).catch((err) => {
            dispatch({
                type: 'GET_CLIENT_CART',
                cart: { ...cart },
                errorOnCart: true
            });
            if(err && err.data){
                Notification.show({
                    type: "error",
                    title:`Error ${err.data.error_code}`,
                    msg: `Error al cargar carritos con mensaje: ${err.data.description}` 
                });
            }
        });
    }
}

export const updateItemFromCart = (body) => {
    return (dispatch, getState) => {
        const { company, cart } = getState();
        return axios.patch(`${URL + company.id}/cart-items/${body.id}`, body).then((res) => {
            res.data.items.forEach(item => {
                item.quantity_real = item.quantity;
            });
            dispatch({
                type: 'GET_CLIENT_CART',
                cart: res.data,
                errorOnCart: false
            });
        }).catch((err) => {
            dispatch({
                type: 'GET_CLIENT_CART',
                cart: { ...cart },
                errorOnCart: true
            });
            if(err && err.data){
                Notification.show({
                    type: "error",
                    title:`Error ${err.data.error_code}`,
                    msg: `Error al cargar carritos con mensaje: ${err.data.description}` 
                });
            }
        });
    }
}

export const clearItemsFromCart = () => {
    return (dispatch, getState) => {
        const { company, cart } = getState();
        return axios.post(`${URL + company.id}/carts/${cart.id}/clear`).then((res) => {
            dispatch({
                type: 'GET_CLIENT_CART',
                cart: res.data,
                errorOnCart: false
            });
        }).catch((err) => {
            dispatch({
                type: 'GET_CLIENT_CART',
                cart: { ...cart },
                errorOnCart: true
            });
            if(err && err.data){
                Notification.show({
                    type: "error",
                    title:`Error ${err.data.error_code}`,
                    msg: `Error al cargar carritos con mensaje: ${err.data.description}` 
                });
            }
        });
    }
}

export const removeItemFromCart = (id) => {
    return (dispatch, getState) => {
        const { company, cart } = getState();
        return axios.delete(`${URL + company.id}/cart-items/${id}`).then((res) => {
            res.data.items.forEach(item => {
                item.quantity_real = item.quantity;
            });
            dispatch({
                type: 'GET_CLIENT_CART',
                cart: res.data,
                errorOnCart: false
            });
        }).catch((err) => {
            dispatch({
                type: 'GET_CLIENT_CART',
                cart: { ...cart },
                errorOnCart: true
            });
            if(err && err.data){
                Notification.show({
                    type: "error",
                    title:`Error ${err.data.error_code}`,
                    msg: `Error al cargar carritos con mensaje: ${err.data.description}` 
                });
            }
        });
    }
}

export const cartCheckout = (body) => {
    return (dispatch, getState) => {
        const { company, cart } = getState();
        return axios.post(`${URL + company.id}/carts/${cart.id}/checkout`, body).then((res) => {
            dispatch({
                type: 'GET_ORDER_CART',
                cartOrder: res.data
            });
        }).catch((err) => {
            dispatch({
                type: 'GET_CLIENT_CART',
                cart: { ...cart },
                errorOnCart: true
            });
            if(err && err.data){
                const error = localizedErrorHandler(err.data);
                if(error.code === "EC603"){
                    Notification.show({
                        type: "error",
                        title:`Error ${error.code}`,
                        msg: `El contenido del carrito es inválido. Por favor revise la información e intente nuevamente.` 
                    });
                } else {
                    Notification.show({
                        type: "error",
                        title:`Error ${error.code}`,
                        msg: `${error.message}` 
                    });
                }
            }
        });
    }
}

export const checkForPromoCode = (body) => {
    return (dispatch, getState) => {
        const { company, branch } = getState();
        return axios.post(`${URL + company.id}/branches/${branch.id}/coupons/check`, body).then((res) => {
            dispatch({
                type: 'CHECKOUT_PROMO_CODE',
                couponCode: {
                    ...res.data,
                    error: null
                }
            });
        }).catch((err) => {
            dispatch({
                type: 'CHECKOUT_PROMO_CODE',
                couponCode: {
                    error: err.data
                }
            });
           
            if(err && err.data){
                const error = localizedErrorHandler(err.data);
                Notification.show({
                    type: "error",
                    title:`Error ${error.code}`,
                    msg: `${error.message}` 
                });
            }
        });
    }
}

export const saveOrderPayment = (orderId, body) => {
    return (dispatch, getState) => {
        const { company, json_lang } = getState();
        return axios.post(`${URL + company.id}/orders/${orderId}/payments/report`, body).then(() => {
            dispatch({
                type: "ERROR_ON_ORDER_PAYMENT",
                errorOnOrderPayment: null
            });
            Notification.show({
                type: "success", 
                title: json_lang.common.success, 
                msg:json_lang.custom_success.saved_successful
            });
        }).catch((err) => {
            if(err && err.data){
                dispatch({
                    type: "ERROR_ON_ORDER_PAYMENT",
                    errorOnOrderPayment: { ...err.data }
                });
                const error = localizedErrorHandler(err.data);
                if(error.code !== "ER423")
                    Notification.show({
                        type: "error",
                        title:`Error ${error.code}`,
                        msg: `${error.message}` 
                    });
            }
        });
    }
}

export const getClientOrders = (search, clientId) => {
    return (dispatch, getState) => {
        const { company, json_lang } = getState();
        return axios.get(`${URL + company.id}/orders?page=1&limit=20&uid=ilike ${encodeURIComponent(search)}&client_id=${encodeURIComponent(clientId)}&is_status_completed=1&mode=all`).then((res) => {
            dispatch({
                type: 'FETCH_CLIENT_ORDERS',
                clientOrders: res.data
            });
        }).catch((err) => {
            if(err && err.data){
                const error = localizedErrorHandler(err.data);
                Notification.show({
                    type: "error",
                    title:`Error ${error.code}`,
                    msg: `${error.message}` 
                });
            } else {
                Notification.show({
                    type: "error",
                    title:`Error`,
                    msg: `${json_lang.two_steps_modal.default_error}` 
                });
            }
        });
    }
}

export const clearClientOrders = () => {
    return (dispatch) => {
        dispatch({
            type: 'FETCH_CLIENT_ORDERS',
            clientOrders: []
        });
    }
}

export const generateOrderCoupon = (couponData, note) => {
    return (dispatch, getState) => {
        const { company, orderDetails } = getState();
          let adminNotes = { admin_notes: note }
          return axios.post(`${URL + company.id}/coupons`, couponData).then((response) => {
              return axios.patch(`${URL}${company.id}/orders/${orderDetails.id}`, adminNotes).then((res) => {
                  dispatch({
                      type: 'FETCH_ORDER_DETAILS',
                      orderDetails: {
                          ...orderDetails,
                          ...res.data
                      },
                  });
                  dispatch({
                      type: 'FETCH_COUPON',
                      coupon: {
                            ...couponData,
                            ...response.data,
                            error: null
                      }
                  });
              }).catch((noteError) => {
                if(noteError && noteError.data){
                    const error = localizedErrorHandler(noteError.data);
                    Notification.show({
                        type: "error",
                        title:`Error ${error.code}`,
                        msg: `${error.message}` 
                    });
                }
              })
          }).catch((err) => {
            if(err && err.data){
                const error = localizedErrorHandler(err.data);
                dispatch({
                    type: 'FETCH_COUPON',
                    coupon: {
                        error: error
                    }
                });
                Notification.show({
                    type: "error",
                    title:`Error ${error.code}`,
                    msg: `${error.message}` 
                });
            }
        });
        
    }
}

export const setReadyOrderCoupon = (couponId) => {
    return (dispatch, getState) => {
        const { company, coupon } = getState();
        coupon.timezone = company.time_zone_offset ? company.time_zone_offset : DEFAULT_TIME_ZONE
        return axios.post(`${URL}${company.id}/coupons/${couponId}/set-ready`, coupon).then((res) => {
            dispatch({
                type: 'FETCH_COUPON',
                coupon: {
                    ...res.data,
                    error: null
                }
            });
        }).catch((err) => {
            if(err && err.data){
                const error = localizedErrorHandler(err.data);
                dispatch({
                    type: 'FETCH_COUPON',
                    coupon: {
                        error: error
                    }
                });
                Notification.show({
                    type: "error",
                    title:`Error ${error.code}`,
                    msg: `${error.message}` 
                });
            }
        });
    }
}

export const getOrderCouponCode = (couponId) => {
   return (dispatch,getState) => {
        let { coupon, company  } = getState();
        return axios.get(`${URL}${company.id}/coupons/${couponId}/codes`).then( (res) => {
            let update = {...coupon,
                available_codes:res.data.available_codes,
                used_codes:res.data.used_codes
            }
            dispatch({
                type: 'FETCH_COUPON',
                coupon: update
            });
        }).catch((err) => {
            if(err && err.data){
                const error = localizedErrorHandler(err.data);
                dispatch({
                    type: 'FETCH_COUPON',
                    coupon: {
                        error: error
                    }
                });
                Notification.show({
                    type: "error",
                    title:`Error ${error.code}`,
                    msg: `${error.message}` 
                });
            }
        });
    }
}

export const setOrderPostPayment = (paymentData) => {
    return (_, getState) => {
        const { company, cartOrder } = getState();
        return axios.post(`${URL + company.id}/orders/${cartOrder.id}/set-post-payment`, paymentData).catch((err) => {
            if(err && err.data){
                const error = localizedErrorHandler(err.data);
                Notification.show({
                    type: "error",
                    title:`Error ${error.code}`,
                    msg: `${error.message}` 
                });
            }
        });
    }
}

export {
    changeStatusOrderProvider,
    fetchHistoryGivechange,
    clearOrderGiveChange,
    toogleOrderGiveChange,
    orderGiveChange,
    setOrderPrivatePool,
    setOrderPublicPool,
    fetchOrdersByStatus,
    getTimelineOrder,
    toogleAssingProvider,
    findOrderWithAvaliableProviders,
    editQuantity,
    dataAsignableOrderParse,
    assigMultiProvider,
    clearBids,
    clearPayment,
    fetchTodayOrders,
    fetchMapOrders,
    markAsTouched,
    clearMapFilters,
    filterOrdersInsideDateRange,
    filterOrdersAssigned,
    filterOrdersUnassigned,
    fetchOrdersByUserType,
    fetchOrdersByProvider,
    filterOrderByStatus,
    fetchArchivedOrders,
    resetDataDetailsOrder,
    unassignProviderFromTable,
    updateProvider,
    updateMapProvider,
    removeProvider,
    fetchOrders,
    addScheduleToOrder,
    cancelOrder,
    confirmOrder,
    modifyInvoice,
    addInstructionsToOrder,
    addClientAddressToOrder,
    addProviderToOrder,
    toggleData,
    addPickupOptionToOrder,
    addDeliveryMethodToOrder,
    addPropertiesToOrder,
    saveOrder,
    addToCart,
    removeGoodsFromOrder,
    removePropertyFromOrder,
    addQuantity,
    substractQuantity,
    addClientToOrder,
    update,
    register,
    find,
    fetchOrderDetails,
    fetchProofOfDelivery,
    destroy,
    registerNewOrder,
    fetchOrderForms,
    acceptOrderPayment,
    completeOrder,
    beginOrder,
    deliverOrder,
    fetchOrderCancelationReason,
    fillDashboardStatistics,
    fillDashboardMonthStatistics,
    fillDashboardDayStatistics,
    drawMonthStatistics,
    newStadistic,
    fetchOrderBids,
    confirmOrderBid,
    cancelOrderBid,
    preloadOrderCart,
    clearCart,
    updateOrderView,
    updateOrdersView,
    drawDasboard,
    addProviderToService,
    beingPreparedOrder,
    preparedOrder,
    drawMonthStatisticsID,
    confirmationToggle,
    toogleOrdeParcialGiveChange,
    orderpParcialGivechange,
    clearOrderParcialGivechange,
    updateShopper,
    resendPool,
    adminNotes,
    addAttachment,
    fetchOrdersBranchHeatmap,
};




// WEBPACK FOOTER //
// ./src/store/actions/orderActions.js